(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brx-password-form"] && !Shopify.designMode) return;
  try {
    (function() {
    var ALLOWED_KEY = 'access';
    var ALLOWED_VALUE = 'dev';

    function checkAccess() {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(ALLOWED_KEY) === ALLOWED_VALUE;
    }

    function initPasswordModal() {
      var modal = document.querySelector('password-modal[data-access-control="restricted"]');

      if (!modal) return;

      if (checkAccess()) {
        modal.style.display = '';
      } else {
        modal.remove();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPasswordModal);
    } else {
      initPasswordModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["privacy-consent-checkbox"] && !Shopify.designMode) return;
  try {
    class PrivacyConsentCheckbox {
    constructor() {
      this.checkboxes = document.querySelectorAll('.privacy-consent__input');
      this.init();
    }

    init() {
      this.checkboxes.forEach(checkbox => {
        const formId = checkbox.dataset.formId;
        const submitSelector = checkbox.dataset.submitSelector;
        const form = document.getElementById(formId);

        if (form) {
          const submitButton = form.querySelector(submitSelector);

          if (submitButton) {
            // Initially disable the submit button
            this.toggleSubmitButton(submitButton, false);

            // Listen for checkbox state changes
            checkbox.addEventListener('change', () => {
              this.toggleSubmitButton(submitButton, checkbox.checked);

              // Clear error when checked
              if (checkbox.checked) {
                this.clearError(checkbox);
              }
            });

            // Validate on form submit
            form.addEventListener('submit', (e) => {
              if (!checkbox.checked) {
                e.preventDefault();
                this.showError(checkbox);
                checkbox.focus(); // Accessibility improvement
                return false;
              }
            });
          }
        }
      });
    }

    toggleSubmitButton(button, enable) {
      button.disabled = !enable;
      button.setAttribute('aria-disabled', (!enable).toString());
      button.style.opacity = enable ? '1' : '0.5';
      button.style.cursor = enable ? 'pointer' : 'not-allowed';
    }

    showError(checkbox) {
      this.clearError(checkbox);

      const container = checkbox.closest('.privacy-consent');
      const errorText = container.dataset.errorMessage ||
                       'You must agree to the privacy policy and terms of service to continue.';

      const errorMessage = document.createElement('div');
      errorMessage.className = 'privacy-consent__error form__message';
      errorMessage.setAttribute('role', 'alert');
      errorMessage.innerHTML = `
        <span class="svg-wrapper">
          <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
            <path d="m5.87413 3.52832c0-0.77735 0.63597-1.41332 1.41332-1.41332s1.41332 0.63597 1.41332 1.41332c0 0.77735-0.63597 1.41332-1.41332 1.41332s-1.41332-0.63597-1.41332-1.41332zm1.90654 1.77699c0 0.24104-0.19537 0.43641-0.43641 0.43641s-0.43641-0.19537-0.43641-0.43641v0.87282c0 0.24104 0.19537 0.43641 0.43641 0.43641s0.43641-0.19537 0.43641-0.43641v-0.87282z" fill="white"/>
          </svg>
        </span>
        ${errorText}
      `;

      container.appendChild(errorMessage);

      // Auto-remove error after 5 seconds
      setTimeout(() => {
        this.clearError(checkbox);
      }, 5000);
    }

    clearError(checkbox) {
      const container = checkbox.closest('.privacy-consent');
      const existingError = container.querySelector('.privacy-consent__error');
      if (existingError) {
        existingError.remove();
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new PrivacyConsentCheckbox();
    });
  } else {
    new PrivacyConsentCheckbox();
  }
  } catch(e) { console.error(e); }
})();

})();
